module.exports = __webpack_public_path__ + "6be715f4428ee88e1c8128cca0cf8063.jpg";